import React, { useState, useContext, useEffect } from "react";
import { LanguageContext } from "../../Languages/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import {
  createDeliverySettings,
  fetchDeliverySettings,
} from "../../../features/dashboard/newBuilderSlice";
import toast from "react-hot-toast";

const DeliverySettings = () => {
  const { t } = useContext(LanguageContext);
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.dashboard);
  const  deliverySettings  = useSelector(
    (state) => state?.dashboard?.deliverySettings?.data,
  );

  const [formData, setFormData] = useState({
    startingPrice: "",
    pricePerKm: "",
    pricePerMinute: "",
  });
  const [initialData, setInitialData] = useState({
    startingPrice: "",
    pricePerKm: "",
    pricePerMinute: "",
  });

  const [errors, setErrors] = useState({
    startingPrice: "",
    pricePerKm: "",
    pricePerMinute: "",
  });

  useEffect(() => {
    dispatch(fetchDeliverySettings());
  }, [dispatch]);

  useEffect(() => {
    if (deliverySettings) {
      const data = {
        startingPrice: deliverySettings.starting_price || "",
        pricePerKm: deliverySettings.price_per_km || "",
        pricePerMinute: deliverySettings.price_per_minute || "",
      };

      setFormData(data);
      setInitialData(data);
    }
  }, [deliverySettings]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.startingPrice)
      newErrors.startingPrice = "Starting price is required.";
    if (!formData.pricePerKm)
      newErrors.pricePerKm = "Price per km is required.";
    if (!formData.pricePerMinute)
      newErrors.pricePerMinute = "Price per minute is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const payload = {
        starting_price: formData.startingPrice,
        price_per_km: formData.pricePerKm,
        price_per_minute: formData.pricePerMinute,
      };

      const resultAction = await dispatch(createDeliverySettings(payload));

      if (createDeliverySettings.fulfilled.match(resultAction)) {
        toast.success("Delivery settings updated successfully!");
        // Fetch again to reflect updated values
        dispatch(fetchDeliverySettings());
      } else {
        toast.error("Failed to update delivery settings.");
      }
    } catch (error) {
      console.error("Error saving delivery settings:", error);
      toast.error("Something went wrong while saving.");
    }
  };

  const isChanged =
    Number(formData.startingPrice) !== Number(initialData.startingPrice) ||
    Number(formData.pricePerKm) !== Number(initialData.pricePerKm) ||
    Number(formData.pricePerMinute) !== Number(initialData.pricePerMinute);

  return (
    <div className="d-flex flex-column container-fluid justify-content-between mb-4">
      <h4 className="text-left fw-bold mb-3 fs-4 text-light">
        {t.deliverySettings}
      </h4>

      <div className="card shadow container mt-5" style={{ maxWidth: "800px" }}>
        <form onSubmit={handleSubmit}>
          {/* Starting Price */}
          <div className="mb-3 mt-5">
            <label className="form-label fw-bold">Starting Price</label>
            <input
              type="number"
              className={`form-control ${
                errors.startingPrice ? "is-invalid" : ""
              }`}
              id="startingPrice"
              placeholder="Enter starting price"
              value={formData.startingPrice}
              onChange={handleChange}
            />
            {errors.startingPrice && (
              <div className=" small mt-1" style={{ color: "red" }}>
                {errors.startingPrice}
              </div>
            )}
          </div>

          {/* Price per km */}
          <div className="mb-3">
            <label className="form-label fw-bold">Price per km</label>
            <input
              type="number"
              className={`form-control ${
                errors.pricePerKm ? "is-invalid" : ""
              }`}
              id="pricePerKm"
              placeholder="Enter price per km"
              value={formData.pricePerKm}
              onChange={handleChange}
            />
            {errors.pricePerKm && (
              <div className="small mt-1" style={{ color: "red" }}>
                {errors.pricePerKm}
              </div>
            )}
          </div>

          {/* Price per minute */}
          <div className="mb-3">
            <label className="form-label fw-bold">Price per minute</label>
            <input
              type="number"
              className={`form-control ${
                errors.pricePerMinute ? "is-invalid" : ""
              }`}
              id="pricePerMinute"
              placeholder="Enter price per minute"
              value={formData.pricePerMinute}
              onChange={handleChange}
            />
            {errors.pricePerMinute && (
              <div className=" small mt-1" style={{ color: "red" }}>
                {errors.pricePerMinute}
              </div>
            )}
          </div>
          <button
            type="submit"
            className="btn btn-light text-info mt-2 mb-5"
            disabled={loading || !isChanged}
            style={{
              opacity: loading || !isChanged ? 0.6 : 1,
              cursor: loading || !isChanged ? "not-allowed" : "pointer",
              transition: "opacity 0.2s ease",
            }}
          >
            <i className="bi bi-save me-2"></i>
            {loading ? "Saving..." : "Save"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeliverySettings;
